(() => {
  const viewers = new WeakMap();
  window.openNaladirseZoom = (dialog, slide) => {
    let viewer = viewers.get(dialog);
    if (!viewer) {
      const content = dialog.querySelector('[data-zoom-content]');
      const image = new Image();
      image.draggable = false;
      content.replaceChildren(image);
      let scale = 1, x = 0, y = 0, width = 0, height = 0, ticket = 0;
      let gesture = null, lastTap = null, lastTouch = 0;
      const pointers = new Map();
      const clamp = (value, limit) => Math.max(-limit, Math.min(limit, value));
      const render = () => {
        x = clamp(x, Math.max(0, (width * scale - content.clientWidth) / 2));
        y = clamp(y, Math.max(0, (height * scale - content.clientHeight) / 2));
        image.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
        content.dataset.enlarged = String(scale > 1);
        const level = dialog.querySelector('[data-zoom-level]');
        const label = `${Number(scale.toFixed(1))}×`;
        if (level.textContent !== label) level.textContent = label;
        dialog.querySelector('[data-zoom-out]').disabled = scale <= 1;
        dialog.querySelector('[data-zoom-in]').disabled = scale >= 4;
      };
      const fit = () => {
        if (!dialog.open || !image.naturalWidth) return;
        const ratio = Math.min(content.clientWidth / image.naturalWidth, content.clientHeight / image.naturalHeight);
        width = image.naturalWidth * ratio;
        height = image.naturalHeight * ratio;
        image.style.width = `${width}px`;
        image.style.height = `${height}px`;
        render();
      };
      const point = (clientX, clientY) => {
        const bounds = content.getBoundingClientRect();
        return { x: clientX - bounds.left - bounds.width / 2, y: clientY - bounds.top - bounds.height / 2 };
      };
      const zoom = (next, focus = { x: 0, y: 0 }) => {
        next = Math.max(1, Math.min(4, next));
        const ratio = next / scale;
        x = focus.x - (focus.x - x) * ratio;
        y = focus.y - (focus.y - y) * ratio;
        scale = next;
        render();
      };
      const reset = () => { scale = 1; x = y = 0; lastTap = null; render(); };
      const startGesture = () => {
        const points = [...pointers.values()];
        if (points.length > 1) {
          lastTap = null;
          gesture = { distance: Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y),
            center: { x: (points[0].x + points[1].x) / 2, y: (points[0].y + points[1].y) / 2 }, scale, x, y, moved: true };
        } else if (points.length) {
          gesture = { start: points[0], x, y, moved: false, time: performance.now() };
        } else gesture = null;
      };
      content.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.pointerType !== 'mouse') lastTouch = performance.now();
        pointers.set(event.pointerId, point(event.clientX, event.clientY));
        content.setPointerCapture(event.pointerId);
        startGesture();
      });
      content.addEventListener('pointermove', event => {
        if (!pointers.has(event.pointerId) || !gesture) return;
        pointers.set(event.pointerId, point(event.clientX, event.clientY));
        const points = [...pointers.values()];
        if (points.length > 1 && gesture.distance) {
          const center = { x: (points[0].x + points[1].x) / 2, y: (points[0].y + points[1].y) / 2 };
          scale = Math.max(1, Math.min(4, gesture.scale * Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y) / gesture.distance));
          const ratio = scale / gesture.scale;
          x = center.x - (gesture.center.x - gesture.x) * ratio;
          y = center.y - (gesture.center.y - gesture.y) * ratio;
        } else if (gesture.start) {
          const dx = points[0].x - gesture.start.x, dy = points[0].y - gesture.start.y;
          if (Math.hypot(dx, dy) > 8) { gesture.moved = true; lastTap = null; }
          if (scale > 1) { x = gesture.x + dx; y = gesture.y + dy; }
        }
        render();
      });
      const finishPointer = event => {
        if (!pointers.has(event.pointerId)) return;
        const focus = pointers.get(event.pointerId);
        if (event.type === 'pointerup' && event.pointerType !== 'mouse' && pointers.size === 1 && gesture && !gesture.moved && performance.now() - gesture.time < 300) {
          if (lastTap && performance.now() - lastTap.time < 320 && Math.hypot(focus.x - lastTap.x, focus.y - lastTap.y) < 30) {
            zoom(scale > 1 ? 1 : 2, focus);
            lastTap = null;
          } else lastTap = { ...focus, time: performance.now() };
        } else lastTap = null;
        pointers.delete(event.pointerId);
        if (content.hasPointerCapture(event.pointerId)) content.releasePointerCapture(event.pointerId);
        startGesture();
        if (pointers.size) { gesture.moved = true; lastTap = null; }
      };
      content.addEventListener('pointerup', finishPointer);
      content.addEventListener('pointercancel', finishPointer);
      content.addEventListener('lostpointercapture', finishPointer);
      content.addEventListener('dblclick', event => {
        if (performance.now() - lastTouch < 500 || (event.pointerType && event.pointerType !== 'mouse')) return;
        zoom(scale > 1 ? 1 : 2, point(event.clientX, event.clientY));
      });
      const bindControl = (selector, action) => {
        const button = dialog.querySelector(selector);
        let press = null, suppressUntil = 0;
        button.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' && !button.disabled) press = { id: event.pointerId, x: event.clientX, y: event.clientY };
        });
        button.addEventListener('pointercancel', () => { press = null; });
        button.addEventListener('pointerup', event => {
          if (!press || press.id !== event.pointerId) return;
          const tapped = Math.hypot(event.clientX - press.x, event.clientY - press.y) < 10;
          press = null;
          if (!tapped || button.disabled) return;
          event.preventDefault();
          suppressUntil = performance.now() + 500;
          action();
        });
        button.addEventListener('click', event => {
          if (event.detail && performance.now() < suppressUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          action();
        });
      };
      bindControl('[data-zoom-in]', () => zoom(scale + .5));
      bindControl('[data-zoom-out]', () => zoom(scale - .5));
      bindControl('[data-zoom-reset]', reset);
      bindControl('[data-gallery-close]', () => dialog.close());
      dialog.addEventListener('keydown', event => {
        if (['+', '=', '-', '0', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
          event.preventDefault();
          if (event.key === '+' || event.key === '=') zoom(scale + .5);
          else if (event.key === '-') zoom(scale - .5);
          else if (event.key === '0') reset();
          else {
            if (event.key === 'ArrowLeft') x += 50;
            if (event.key === 'ArrowRight') x -= 50;
            if (event.key === 'ArrowUp') y += 50;
            if (event.key === 'ArrowDown') y -= 50;
            render();
          }
        }
      });
      dialog.addEventListener('close', () => {
        ticket++;
        pointers.clear();
        gesture = lastTap = null;
        reset();
      });
      image.addEventListener('load', fit);
      new ResizeObserver(fit).observe(content);
      viewer = {
        open: async selected => {
          const currentTicket = ++ticket;
          const visible = selected.querySelector('img');
          reset();
          image.alt = visible.alt;
          image.src = visible.currentSrc || visible.src;
          dialog.showModal();
          fit();
          const full = new Image();
          full.src = selected.dataset.large;
          try {
            await full.decode();
            if (dialog.open && ticket === currentTicket) image.src = full.src;
          } catch {}
        }
      };
      viewers.set(dialog, viewer);
    }
    viewer.open(slide);
  };
})();
